import {
	USER_LOGIN,
	USER_LOGIN_EMAIL_AUTHORIZE,
	USER_LOGIN_ACCESS,
	USER_LOGIN_VERIFY_GOOGLE_2FA,
	USER_VERIFY_USER_AND_EMAIL,
	USER_SIGNUP_SEND_SMS,
	USER_SIGNUP_VERIFY_SMS_CODE,
	USER_SIGNUP_GOOGLE_2FA,
	USER_SIGNUP_COMPLETE_REGISTRATION,	
	USER_LOGOUT,
	CHANGE_USER_PROPS,
	UPDATE_USER_DATA,
    UPDATE_TOKEN
} from '../action-types';
import { handleActions } from 'redux-actions';
import { cloneDeep } from 'lodash';

const initialState = {
	user: {},
	image: '',	
	admin: false,
	user_name: '',
	error: '',
	googleAuthImg: '',
	googleAuthCode: '',
};

function updateState(state, newProps) {
	let newState = Object.assign({}, state, newProps);
	return newState;
}

export const user = handleActions(
	{
		[CHANGE_USER_PROPS]: (state, action) => {
			let newState = updateState(state, action.payload);
			return newState;
		},

		[UPDATE_USER_DATA]: (state, action) => {
			let user = cloneDeep(state.user);

			let newUser = Object.assign({}, user, action.payload);

			let newState = updateState(state, { user: newUser });

			return newState;
		},

		[USER_VERIFY_USER_AND_EMAIL]: (state, action) => {
			// Si el usuario existe: action.payload es:
			// {
			// code: 314
			// message: "the user exists"
			// status: "error"
			// }

			// Si el usuario no existe: action.payload es:
			// {
			//     code: 203
			//     message: "username does not exist"
			//     status: "success"
			// }

			if (action.error) {
				let newState = updateState(state, {
					user: {},					
					admin: false,
					user_name: '',
					error: 'El Usuario ya existe.',
				});

				return newState;
			}

			return state;
		},

		[USER_SIGNUP_SEND_SMS]: (state, action) => {
			// SMS enviado (aunque el num no sea correcto) action.payload es:
			// {
			//     code: 204
			//     message: "SMS sent successfully"
			//     status: "success"
			// }

			if (action.error) {
				let newState = updateState(state, {
					user: {},					
					admin: false,
					user_name: '',
					error: 'No se ha podido enviar el SMS.',
				});

				return newState;
			}

			return state;
		},

		[USER_SIGNUP_VERIFY_SMS_CODE]: (state, action) => {
			// al ingresar el codigo recibido action.payload es:
			// {
			//     code: 205
			//     message: "SMS valid"
			//     status: "success"
			// }

			// si ingreso codigo invalido action.payload es:
			// {
			//     code: 312
			//     message: "SMS does not exist"
			//     status: "error"
			// }

			

			return state;
		},

		[USER_SIGNUP_GOOGLE_2FA]: (state, action) => {
			// action.payload:
			// QR_image: "data:image/png;base64,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"
			// code: 205
			// google2fa_secret: "WOFPZFQEEGRFMR6V"
			// message: "google 2fa builder"
			// status: "success"

			if (action.error) {
				let newState = updateState(state, {
					googleAuthImg: '',
					googleAuthCode: '',					
					admin: false,
					user_name: '',
					error: 'No podemos obtener el código del Autenticador de Google.',
				});

				return newState;
			}

			let user = cloneDeep(state.user);
			//let admin = cloneDeep(state.admin);

			let newUser = Object.assign({}, user, {
				google2fa_secret: action.payload.google2fa_secret,
			});

			let newState = updateState(state, {
				user: newUser,
				//admin: admin,
				googleAuthImg: action.payload.QR_image,
				googleAuthCode: action.payload.google2fa_secret,
				error: '',
			});

			return newState;
		},

		[USER_SIGNUP_COMPLETE_REGISTRATION]: (state, action) => {
			//console.log("USER_SIGNUP_COMPLETE_REGISTRATION: ", action);
			// action.payload es:
			// {
			//     status: "success",
			//     message: "full user registration",
			//     code: 206,
			//     access_token: "99342fcff4fc890a063ab47770e321fc27e9f6993654295b00ea7caa44c53c7a"
			// }

			if (action.error) {
				let newState = updateState(state, {
					googleAuthImg: '',
					googleAuthCode: '',					
					//admin: false,
					error: 'No se ha podido completar su registro.',
				});

				return newState;
			}

			//localStorage.setItem('signup_token', action.payload.access_token);

			return state;
		},

		[USER_LOGIN]: (state, action) => {
			// console.log('action', action);
			//
			// Error:
			// action = {
			//     error: true,
			//     payload: {
			//         code: 352,
			//         message: "user inactive by email",
			//         status: "error"
			//     },
			//     type: "USER_LOGIN"
			// }

			// Succcess:
			// action.payload = {
			//     "status": "success",
			//     "message": "authenticated user",
			//     "code": 805,
			//     "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC93d3cuZ3BzY29pbi5pb1wvclwvYXBpXC9sb2dpbiIsImlhdCI6MTU5ODU1NjUwMCwiZXhwIjoxNTk4NTYwMTAwLCJuYmYiOjE1OTg1NTY1MDAsImp0aSI6Ik5raHBQek1rdHVjZnI2Q3YiLCJzdWIiOjEzNjU4Nzg0MSwicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.4IA7MqCQYM4ioxwEvVJ1Jp8TLMuROgHc-XlS6MeYl68"
			// }

			if (action.error) {
				let newState = updateState(state, {
					user: {},					
					accessApproved: '',
					error: action.payload.message,
				});

				return newState;
			}

			sessionStorage.setItem('token', action.payload.token);

			let newState = updateState(state, {				
				token: action.payload.token,
				error: ''
			});

			return newState;
		},

		[USER_LOGIN_VERIFY_GOOGLE_2FA]: (state, action) => {
			// console.log('action', action);
			// Error:
			// action = {
			//     error: true,
			//     payload: { status: "error", message: "Google2FA invalid", code: 313 },
			//     type: "USER_LOGIN_VERIFY_GOOGLE_2FA"
			// }

			// Success:
			// action.payload = {
			//     avatar: "default",
			//     code: 806,
			//     created_at: "2020-08-27T22:34:56.000000Z",
			//     email: "santiagor88@yopmail.com",
			//     message: "Google2FA valid",
			//     status: "success",
			//     usuario: "santiagor88"
			// }

			if (action.error) {
				let newState = updateState(state, {
					accessApproved: '',
					error: action.payload.message,
				});

				return newState;
			}

			let newState = updateState(state, {
				accessApproved: '',
				error: action.payload.message,
			});

			return newState;
		},

		[USER_LOGIN_EMAIL_AUTHORIZE]: (state, action) => {
			// console.log('action', action);
			if (action.error) {
				return initialState;
			}

			return state;
		},

		[USER_LOGIN_ACCESS]: (state, action) => {
			// console.log('action', action);
			if (action.error) {
				let newState = updateState(state, {
					accessApproved: '',
					error: action.payload.message,
				});

				return newState;
			}
			
			let newState = updateState(state, {
				user: {
					usuario: action.payload.usuario,
					email: action.payload.email,
					telefono: action.payload.telefono,
					avatar: action.payload.avatar,
					kyc: action.payload.kyc,
					preferences: JSON.parse(action.payload.preferences),
					roles: action.payload.roles					
				}
			});

			/* NO BORRAR
			if(action.payload.token){
				console.log("Paso");
                // sessionStorage.setItem('token', action.payload.token); 
                newState.user.token = action.payload.token; 
                console.log(newState);

            } */
                    
			return newState;
		},

		[USER_LOGOUT]: (state, action) => {
			localStorage.removeItem('token');
			localStorage.removeItem('admin');
			localStorage.removeItem('user_name');
			return initialState;
		},

        [UPDATE_TOKEN]: (state, action) => {
        
            sessionStorage.setItem('token', action.payload.token);

            return state;

        }



	},
	initialState
);
